(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exit-intent-popup"]) return;
  try {
    
  (function () {
    var KEY = 'ch_exit_seen_v1';
    var DAYS = 14;
    var popup = document.querySelector('[data-ch-exit]');
    if (!popup) return;

    // Skip on cart, checkout, account, thank-you pages
    var path = location.pathname;
    if (/\/(cart|checkout|account|orders|challenge)/i.test(path)) return;

    // Respect cooldown
    try {
      var last = localStorage.getItem(KEY);
      if (last && (Date.now() - parseInt(last, 10)) < DAYS * 86400000) return;
    } catch (e) { /* private mode */ }

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      popup.hidden = false;
      requestAnimationFrame(function () { popup.setAttribute('data-open', 'true'); });
      try { localStorage.setItem(KEY, Date.now().toString()); } catch (e) {}
    }
    function hide() {
      popup.setAttribute('data-open', 'false');
      setTimeout(function () { popup.hidden = true; }, 260);
    }

    // Desktop: mouse leaves top of viewport
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (!isMobile) {
      document.addEventListener('mouseout', function (e) {
        if (!e.toElement && !e.relatedTarget && e.clientY < 10) show();
      });
    } else {
      // Mobile: show after 35s OR on rapid scroll-up after engagement
      var engaged = false;
      setTimeout(function () { engaged = true; }, 20000);
      var lastY = window.scrollY;
      var fastUp = 0;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (engaged && lastY - y > 80) {
          fastUp++;
          if (fastUp >= 2) show();
        } else { fastUp = 0; }
        lastY = y;
      }, { passive: true });
      setTimeout(function () { show(); }, 40000);
    }

    // Close handlers
    popup.querySelectorAll('[data-ch-exit-close]').forEach(function (el) {
      el.addEventListener('click', hide);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
